module.exports = __webpack_public_path__ + "static/photo4-2d9bdbbee1aef6a466b9af0833e3fe92.jpg";